import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, queryIban } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const AddBankAccount = Loadable({
    loader: () => import('./AddBankAccount'),
    render(loaded, props) {
      const Component = connect((state) => ({
        bankCardAddBankAccountState: state.bankCardAddBankAccountState,
        siteConfig: state.siteConfig
      }), {
        init,
        queryIban
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/add-bank-account`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <AddBankAccount {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
